const pisFragments = {
    bindings: {
    },
    templateUrl: '/modules/pis-tool/fragments/pis-fragments.html',
    controller: 'PisFragmentsController',
};

angular
    .module('pis-tool.module')
    .component('pisFragments', pisFragments)
    .config(function($stateProvider) {
        $stateProvider.state('pis.workspaces.fragments', {
            url: '/fragments',
            views: {
                'pisview@pis': 'pisFragments',
            },
            resolve: {
                // workSpaces: PISService => PISService.getAllWorkspaces(),
            },
        });
    });
